import apiClient from './client';

// =============================================
// Push Notifications API
// =============================================

export const pushApi = {
  getVapidKey: async (): Promise<string> => {
    const response = await apiClient.get<{ public_key: string }>('/push/vapid-key');
    return response.data.public_key;
  },

  subscribe: async (subscription: PushSubscriptionJSON): Promise<void> => {
    await apiClient.post('/push/subscribe', subscription);
  },

  unsubscribe: async (endpoint: string): Promise<void> => {
    await apiClient.post('/push/unsubscribe', { endpoint });
  },

  test: async (): Promise<void> => {
    await apiClient.post('/push/test');
  },
};
